import React from "react";
import Power from "../../shared/Power/Power";
import { Avatar } from "antd";
import { profileCharacters } from "../../utils/helper";
import sx from "../../styles/new_styles/blog_card.module.scss";
import { useHistory } from "react-router-dom";
import {
  HeartOutlined,
  ShareAltOutlined,
  UserAddOutlined,
} from "@ant-design/icons";

const BlogCard = ({ blog }) => {
  const history = useHistory();
  return (
    <div
      onClick={() => history.push(`/blogfolio/${blog?.urlSlug}/about`)}
      className={sx.root}
    >
      <div className={sx.header} style={{ cursor: "pointer" }}>
        <div className={sx.avatar}>
          <Avatar
            size={49}
            icon={profileCharacters(
              blog?.author?.firstName,
              blog?.author?.lastName
            )}
            src={blog?.author?.profileImage}
          />
        </div>

        <div className={sx.details}>
          <h6 className={sx.title}> {blog?.title} </h6>
          <p className={sx.subtitle}>
            by Dr. {blog?.author?.firstName}{" "}
            {blog?.author?.lastName ? blog?.author?.lastName : ""}{" "}
          </p>
        </div>
      </div>

      <div className={sx.bottom}>
        <div className={sx.iconParent}>
          <div className={sx.iconWrapper}>
            <HeartOutlined /> • {blog?.likeCount}
          </div>
          <div className={sx.iconWrapper}>
            <UserAddOutlined /> • {blog?.followCount}
          </div>
          <div className={sx.iconWrapper}>
            <ShareAltOutlined /> • {blog?.shareCount}
          </div>
        </div>

        <div>
          <Power count={blog?.powerScore} />
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
